import {Directive, output, signal} from '@angular/core';

import {RequestViewModel} from '../../view-models/request.view-model';
import {RequestStepDetailViewModel} from '../../view-models/request-step-detail.view-model';
import {RequestStepStateViewModel} from '../../view-models/request-step-state.view-model';
import {RequestStepUpdateDto} from '@dto/requests/request-step-update.dto';

@Directive()
export abstract class BaseRequestComponent {
  public readonly previousClicked = output<void>();
  public readonly nextClicked = output<void>();
  public readonly closeClicked = output<void>();
  public readonly requestUpdated = output<RequestStepUpdateDto>();
  public readonly processingUpdated = output<boolean>();

  public readonly request = signal<RequestViewModel>(undefined!);
  public readonly step = signal<RequestStepDetailViewModel>(undefined!);
  public readonly state = signal<RequestStepStateViewModel>(undefined!);
  private processingFlag = false;

  public initialize(request: RequestViewModel,
                    step: RequestStepDetailViewModel,
                    state: RequestStepStateViewModel): void {
    this.request.set(request);
    this.step.set(step);
    this.state.set(state);
  }

  public previous(): void {
    this.previousClicked.emit();
  }

  public next(): void {
    this.nextClicked.emit();
  }

  public close(): void {
    this.closeClicked.emit();
  }

  public updateRequest(updatedRequest: RequestStepUpdateDto): void {
    this.requestUpdated.emit(updatedRequest);
  }

  public get processing(): boolean {
    return this.processingFlag;
  }

  protected set processing(value: boolean) {
    this.processingFlag = value;
    this.processingUpdated.emit(value);
  }
}
